<template>
  <div class="app-container">
    <div class="filter-container">
      <el-row type="flex" justify="end" align="middle">
        <div class="px-10 filter-item">用户</div>
        <el-input
          v-model="listQuery.username"
          placeholder="请输入用户名称"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <el-input
          v-model="listQuery.last_name"
          placeholder="请输入姓"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <el-input
          v-model="listQuery.first_name"
          placeholder="请输入名"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <el-input
          v-model="listQuery.user_id"
          placeholder="请输入用户ID"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <el-input
          v-model="listQuery.uuid"
          placeholder="请输入UUID"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <div class="px-10 filter-item">会员套餐名称</div>
        <el-input
          v-model="listQuery.vip_product_name"
          placeholder="请输入会员套餐名称"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <el-select
          v-model="listQuery.status"
          placeholder="状态"
          clearable
          style="width: 200px"
          class="filter-item"
        >
          <el-option label="正常" value="normal" />
          <el-option label="部分退款" value="partial_refund" />
          <el-option label="已退款" value="refunded" />
        </el-select>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
          >搜索</el-button
        >
      </el-row>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="订单号" width="120">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="会员ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_id || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="UUID" width="120">
        <template slot-scope="scope">
          {{ scope.row.uuid }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户名称" width="120">
        <template slot-scope="scope">
          {{ scope.row.username || '' }}
        </template>
      </el-table-column>
      <el-table-column label="名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.first_name || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="姓" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.last_name || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="会员套餐名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="价格" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.vip_product.price }}
        </template>
      </el-table-column>
      <el-table-column
        label="会员有效期（点数）"
        min-width="110"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.vip_product.vip_point }}
        </template>
      </el-table-column>
      <el-table-column label="可获得奖励代数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.vip_product.can_receive_reward_gene_num }}
        </template>
      </el-table-column>
      <el-table-column label="购买时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_created_at }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" min-width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 'normal'" type="">正常</el-tag>
          <el-tag
            v-else-if="scope.row.status === 'partial_refund'"
            type="success"
            >部分退款</el-tag
          >
          <el-tag v-else-if="scope.row.status === 'refunded'" type="danger"
            >已退款</el-tag
          >
        </template>
      </el-table-column>
      <!--      <el-table-column-->
      <!--        label="操作"-->
      <!--        align="center"-->
      <!--        min-width="230"-->
      <!--        class-name="small-padding fixed-width"-->
      <!--      >-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-button size="mini" type="warning" @click="edit(scope.row)">-->
      <!--            冻结-->
      <!--          </el-button>-->
      <!--          <el-button size="mini" type="primary"> 同意 </el-button>-->
      <!--          <el-button size="mini" type="primary"> 驳回 </el-button>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="驳回"
      :visible.sync="rejectModalVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body
      width="512px"
    >
      <el-form
        ref="rejectForm"
        :model="rejectForm"
        :rules="rejectRules"
        label-width="0px"
      >
        <el-form-item prop="reason">
          <el-input
            type="textarea"
            placeholder="驳回理由"
            :rows="4"
            v-model="rejectForm.reason"
          ></el-input>
        </el-form-item>
        <el-row type="flex" justify="end">
          <el-button @click="rejectModalVisible = false">取消</el-button>
          <el-button type="primary" @click="reject('rejectForm')"
            >确认</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      rejectModalVisible: false,
      rejectRules: {
        reason: [
          { required: true, message: '请填写驳回理由', trigger: 'blur' },
        ],
      },
      rejectForm: {
        id: '',
        reason: '',
      },
      list: null,
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        user_id: '',
        username: '',
        vip_product_name: '',
        status: '',
      },
    }
  },
  created() {
    this.getList()
  },
  watch: {
    rejectModalVisible() {
      this.rejectForm = {
        ...this.rejectForm,
        reason: '',
      }
    },
  },
  methods: {
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/vip/buyLogs',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    edit(val) {
      this.$router.push('/member/editmemberinfo')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
